export default "__VITE_ASSET__B6Jdix7g__"